import { FC } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../common/components/Button'
import { ApiShippingAddress } from '../../../api/quotes/types/ApiShippingAddress'
import { CreateQuoteFormData } from '../model/types'
import { MoneyView } from '../../../common/components/MoneyView'

const Summary = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing.md,
}))

const SummaryRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing.xs,
}))

const SummaryLabel = styled('span')(({ theme }) => ({
  fontSize: theme.fontSize.small,
  color: theme.colors.text.muted,
}))

const SummaryValue = styled('span')(({ theme }) => ({
  fontSize: theme.fontSize.regular,
  color: theme.colors.text.primary,
}))

const Buttons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing.sm,
  marginTop: theme.spacing.sm,
}))

interface CreateQuoteConfirmationStepProps {
  formData: CreateQuoteFormData
  addresses: ApiShippingAddress[]
  loading: boolean
  onBack: () => void
  onConfirm: () => void
}

export const CreateQuoteConfirmationStep: FC<CreateQuoteConfirmationStepProps> = ({
  formData,
  addresses,
  loading,
  onBack,
  onConfirm,
}) => {
  const { t } = useTranslation()

  const selectedAddress = addresses.find((a) => a.id === formData.shippingAddressId)

  return (
    <Summary>
      <SummaryRow>
        <SummaryLabel>{t('Reference number')}</SummaryLabel>
        <SummaryValue>{formData.referenceNumber || '–'}</SummaryValue>
      </SummaryRow>

      <SummaryRow>
        <SummaryLabel>{t('Shipping address')}</SummaryLabel>
        <SummaryValue>{selectedAddress?.address ?? '–'}</SummaryValue>
      </SummaryRow>

      <SummaryRow>
        <SummaryLabel>{t('Shipping cost')}</SummaryLabel>
        <SummaryValue>
          <MoneyView value={{ value: formData.customShippingCost, currency: selectedAddress?.price.currency ?? '' }} />
        </SummaryValue>
      </SummaryRow>

      <Buttons>
        <Button primary big disabled={loading} onClick={onConfirm}>
          {loading ? t('Loading...') : t('Confirm')}
        </Button>

        <Button big disabled={loading} onClick={onBack}>
          {t('Back')}
        </Button>
      </Buttons>
    </Summary>
  )
}
